<template>
  <div class="modal-card addUser">
    <div class="modal-card-head">
      <div class="modal-card-title">External legal representative access request</div>
    </div>
    <div class="modal-card-body">
      <div class="columns">
        <div class="column">

          <b-field label="First name">
            <b-input placeholder="First Name" type="text" v-model="request.FirstName"></b-input>
          </b-field>

          <b-field label="Last name">
            <b-input placeholder="Last Name" type="text" v-model="request.LastName"></b-input>
          </b-field>

          <b-field label="Email">
            <b-input placeholder="Email" type="email" v-model="request.Email"></b-input>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Expires on">
            <b-datepicker v-model="request.Expires"></b-datepicker>
          </b-field>

          <b-field label="Organization">
            <b-input placeholder="Organization's Name" type="text" v-model="request.Organization"></b-input>
          </b-field>

          <b-field label="Organization Address">
            <b-input placeholder="Organization's Address" type="text" v-model="request.OrganizationAddress"></b-input>
          </b-field>
        </div>
      </div>
    </div>
    <div class="modal-card-foot">
      <b-button @click="$parent.close()">Close</b-button>

      <div class="is-pulled-right">
        <div v-if="Request.Status == 'In Progress'">
          <b-button class="is-danger" @click="deny">Deny</b-button>
          <b-button class="is-primary" @click="approve">Approve</b-button>
        </div>
        <div v-if="Request.Status != 'In Progress'">
          <span>{{ Request.Status }}</span>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
  export default {
    props: {
      Request: Object
    },
    data() {
      return {
        request: {},
        roles: []
      }
    },
    created() {
      this.request = JSON.parse(JSON.stringify(this.Request));
      let names = this.Request.Name.split(" ");
      this.request.FirstName = names[0];
      this.request.LastName = names[1];
      this.request.Expires = new Date(this.Request.Expires);

      this.request
    },
    methods: {
      approve() {
        if (this.request.OrganizationAddress && this.request.Organization && this.request.FirstName && this.request.LastName && this.request.Expires && this.request.Email) {
          this.request.Name = this.request.FirstName + " " + this.request.LastName;
          this.request.Expires = new Date(this.request.Expires);
          this.request.Status = null;
          this.$http.post("api/request/external/approve", this.request)
            .then(resp => {
              this.$buefy.toast.open(resp.data);
              this.$parent.close();
              this.$emit("refresh");
            }).catch(e => {
              console.error(e)
            });
        }
        else {
          this.$buefy.toast.open("You must fill out all fields.");
        }
      },
      deny() {
        this.$http.get("api/request/deny/" + this.request.Id)
          .then(resp => {
            this.$buefy.toast.open(resp.data);
            this.$parent.close();
            this.$emit("refresh");
          }).catch(e => {
            console.error(e)
          });
      },
    }
  }
</script>
